import React, {Component} from 'react'
import { sendInviteEmailByAdmin } from '../../utils/Customer.js'

class Activate extends Component {
  constructor(props) {
    super(props)
    this.state = {
      email: props.email,
      message: null,
    }
  }

  submitData() {
    const submitBtn = document.querySelector('[data-register-submit]')
    sendInviteEmailByAdmin((data) => {
      if(!data?.errors.length) {
        this.setState({
          message: window.accountStrings.popup.activationEmailSent,
        })
        submitBtn.innerHTML = window.accountStrings.popup.invited
      }
    },
    {
      id: window.queryCustomer.id
    })
  }

  render() {
    return (
      <div>
        <button className='button button--primary w-full mb-7.5'
          id='activateSubmit' 
          onClick={e => this.submitData()}
          data-register-submit
        >
          {window.accountStrings.popup.activateAccount}
        </button>
        { this.state.message && <div className="text-xs mb-7.5 normal-case">{ this.state.message }</div> }

        <div className="normal-case text-fourth-grey text-xs popup-privacy-terms" dangerouslySetInnerHTML={{ __html: window.accountStrings.popup.privacyTerms }} />
      </div>
    )
  }
}

export default Activate